// extracted by mini-css-extract-plugin
module.exports = {"bottom":"footer-bottom_bottom__u4BGH","text-box":"footer-bottom_text-box__cZ2kd","text":"footer-bottom_text__RTBjM"};